<div class="gw-rd-page-widget-layout">
    <slot />
</div>

<style lang="postcss">
    .gw-rd-page-widget-layout {
        width: 100%;
        max-width: 1118px;
        display: flex;
        flex-direction: column;
        gap: clamp(var(--gw-rd-space-10), 4vw, var(--gw-rd-space-24));
        justify-items: center;
        margin: 0 auto;
        text-align: center;
    }
</style>
